import React, { useEffect, useState } from "react";
import BottomNav from "./BottomNav";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CssBaseline from "@material-ui/core/CssBaseline";
import Slider from "@material-ui/core/Slider";
import Input from "@material-ui/core/Input";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import AppBar from "./AppBar";
import Button from "@material-ui/core/Button";

function CalculateTip() {
  const [billTotal, setBillTotal] = useState("");
  const [remTip, setRemTip] = useState("");
  const [tip, setTip] = useState("");
  const [remTotal, setRemTotal] = useState("");
  const [total, setTotal] = useState("");
  const [sliderValue, setSliderValue] = React.useState(15);

  const [splitTip, setSplitTip] = useState("");
  const [splitTotal, setSplitTotal] = useState("");
  const [splitSliderValue, setSplitSliderValue] = React.useState(1);

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
    setTip((Number(billTotal) * (Number(newValue) / Number(100))).toFixed(2));
    setRemTip(
      (Number(billTotal) * (Number(newValue) / Number(100))).toFixed(2)
    );
    setSplitTip((Number(tip) / Number(splitSliderValue)).toFixed(2));
    setSplitTotal((Number(total) / Number(splitSliderValue)).toFixed(2));
  };

  const handleInputChange = (event) => {
    setSliderValue(event.target.value === "" ? "" : Number(event.target.value));
  };

  const handleBlur = () => {
    if (sliderValue < 0) {
      setSliderValue(0);
    } else if (sliderValue > 100) {
      setSliderValue(100);
    }
  };

  const handleSplitSliderChange = (event, newValue) => {
    setSplitSliderValue(newValue);
    setSplitTip((Number(tip) / Number(newValue)).toFixed(2));
    setSplitTotal((Number(total) / Number(newValue)).toFixed(2));
    setTip(remTip);
    setRemTotal(remTotal);
  };

  const handleSplitInputChange = (event) => {
    setSplitSliderValue(
      event.target.value === "" ? "" : Number(event.target.value)
    );
  };

  const handleSplitBlur = () => {
    if (splitSliderValue < 0) {
      setSplitSliderValue(0);
    } else if (splitSliderValue > 100) {
      setSplitSliderValue(100);
    }
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
    margin: {
      height: theme.spacing(3),
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    if (billTotal != "") {
      if (billTotal > 500000) {
        setBillTotal(500000);
      } else {
        if (sliderValue == 0) {
          setTip(Number(billTotal).toFixed(2) * Number(sliderValue / 100));
          setRemTip(Number(billTotal).toFixed(2) * Number(sliderValue / 100));
          setTotal(Number(billTotal).toFixed(2));
          setRemTotal(Number(billTotal).toFixed(2));
          setSplitTip(Number(tip) / Number(splitSliderValue).toFixed(2));
        } else {
          setRemTip(
            (Number(billTotal).toFixed(2) * Number(sliderValue / 100)).toFixed(
              2
            )
          );
          setTip(
            (Number(billTotal).toFixed(2) * Number(sliderValue / 100)).toFixed(
              2
            )
          );
        }
      }
    } else {
      setTip("");
      setTotal("");
      setSplitTip("");
      setSplitTotal("");
    }
  }, [billTotal]);

  useEffect(() => {
    setTotal((Number(billTotal) + Number(tip)).toFixed(2));
    setRemTotal((Number(billTotal) + Number(tip)).toFixed(2));
    setSplitTip((Number(tip) / Number(splitSliderValue)).toFixed(2));
  }, [tip]);

  useEffect(() => {
    setSplitTotal((Number(total) / Number(splitSliderValue)).toFixed(2));
  }, [total]);

  const roundUp = (e) => {
    e.preventDefault();
    var x = (Number(billTotal) + Number(tip)).toFixed(2);
    var value = parseInt(x) + 1 + ".00";
    if (sliderValue != 0) {
      if (x % 1 != 0) {
        setTotal(value);
        setTip((Number(value) - Number(billTotal)).toFixed(2));
        setSplitTotal((Number(x) / Number(splitSliderValue)).toFixed(2));
      }
    } else {
      if (x % 1 != 0) {
        setTotal(value);
        setSplitTotal(value);
      }
    }
  };

  const roundDown = (e) => {
    e.preventDefault();
    var x = (Number(billTotal) + Number(tip)).toFixed(2);
    if (x % 1 != 0) {
      setTotal(parseInt(x) + ".00");
      //setTip(parseInt(tip) + ".00");
    }
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar />
      <br />
      <br />
      <br />
      <Container>
        <div className={classes.root}>
          <Card
            variant="outlined"
            style={{ backgroundColor: "#e6e6e6", marginTop: "10px" }}
          >
            <CardContent>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <Typography variant="subtitle1" justify="center">
                    Bill Total (R):
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Input
                    value={billTotal}
                    style={{ width: "100%" }}
                    placeholder={"0"}
                    id="billTotal"
                    label="Bill Total"
                    type="number"
                    min="10"
                    onChange={(event) =>
                      setBillTotal(event.target.value.trim())
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1" justify="center">
                    Tip (R):
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Input
                    style={{ width: "100%", height: "48px" }}
                    readOnly={true}
                    id="tip"
                    label="Tip"
                    type="number"
                    value={tip}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1" justify="center">
                    Total (R):
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Input
                    style={{ width: "100%", height: "48px" }}
                    readOnly={true}
                    id="total"
                    label="Total"
                    type="number"
                    value={total}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    variant="subtitle1"
                    justify="center"
                    value={total}
                  >
                    Tip %:
                  </Typography>
                </Grid>

                <Grid item xs={8}>
                  <Slider
                    value={typeof sliderValue === "number" ? sliderValue : 0}
                    onChange={handleSliderChange}
                    aria-labelledby="input-slider"
                    min={0}
                    max={100}
                    style={{ marginTop: "30px" }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Input
                    readOnly={true}
                    disableUnderline={true}
                    className={classes.input}
                    value={sliderValue}
                    margin="dense"
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    inputProps={{
                      step: 5,
                      min: 0,
                      max: 150,
                      type: "number",
                      "aria-labelledby": "input-slider",
                      style: { paddingLeft: "10px", marginTop: "30px" },
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <br />
          <Card variant="outlined" style={{ backgroundColor: "#e6e6e6" }}>
            <CardContent>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Grid item xs={2}>
                  <Typography
                    variant="subtitle1"
                    justify="center"
                    value={total}
                  >
                    Split:
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Slider
                    value={
                      typeof splitSliderValue === "number"
                        ? splitSliderValue
                        : 0
                    }
                    min={1}
                    max={30}
                    onChange={handleSplitSliderChange}
                    aria-labelledby="input-slider"
                  />
                </Grid>
                <Grid item xs={2}>
                  <Input
                    readOnly={true}
                    disableUnderline={true}
                    className={classes.input}
                    value={splitSliderValue}
                    margin="dense"
                    onChange={handleSplitInputChange}
                    onBlur={handleSplitBlur}
                    inputProps={{
                      step: 5,
                      min: 1,
                      max: 50,
                      type: "number",
                      "aria-labelledby": "input-slider",
                      style: { paddingLeft: "10px" },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1" justify="center">
                    Split Tip (R):
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Input
                    style={{ width: "100%", height: "48px" }}
                    readOnly={true}
                    id="tip"
                    label="Tip"
                    type="number"
                    value={splitTip}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1" justify="center">
                    Split Total (R):
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Input
                    style={{ width: "100%", height: "48px" }}
                    readOnly={true}
                    id="total"
                    label="Total"
                    type="number"
                    value={splitTotal}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>
        <br />
        <Typography variant="subtitle1" justify="center">
          Round Total:
        </Typography>
        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={roundDown}
              style={{ marginRight: "50px" }}
            >
              Down
            </Button>
            <Button variant="contained" color="primary" onClick={roundUp}>
              Up
            </Button>
          </Grid>
        </Grid>
        <br /> <br /> <br />
      </Container>
      <BottomNav active={0} />
    </React.Fragment>
  );
}

export default CalculateTip;
